export default {"src":"/_next/static/media/comments-icon.48b259e4.svg","height":32,"width":31,"blurWidth":0,"blurHeight":0};